import { useQuery } from "@tanstack/react-query";

import { predictionFeedbackQuery } from "#modules/feedback/infra/predictionFeedback.query";

export const usePredictionFeedback = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...predictionFeedbackQuery(id) });

  return { predictionFeedback: data, ...rest };
};
